import styled from "@emotion/styled";
import React from "react";
import { Page } from "../../activities/AppPage";
import { STRINGS } from "../../strings";
import { translate } from "../../translate";
import { AppList, AppListItem } from "../Generic/AppList";
import TrailingChevron from "../Generic/TrailingChevron/TrailingChevron";
import GenericSettingsScreen from "../GenericSettingsScreen";
import { PdfDocument } from "./PdfDocument";

interface Props {
  requirements: PdfDocument[];
  onClickGoBack: () => void;
  onRequestNavigate: (page: Page) => void;
}

const ImportantInformationScreen = (props: Props) => {
  return (
    <ImportantInformationScreen.GenericSettingsScreenContainer>
      <GenericSettingsScreen
        title={translate(STRINGS.IMPORTANT_INFORMATION)}
        onClickGoBack={props.onClickGoBack}
      >
        <AppList bordered={true}>
          {props.requirements.map((requirement) => (
            <AppListItem
              key={requirement.title}
              title={requirement.title}
              trailing={<TrailingChevron />}
              onClick={() =>
                props.onRequestNavigate({
                  type: "DocumentDownload",
                  documentType: requirement.type,
                })
              }
            />
          ))}
        </AppList>
      </GenericSettingsScreen>
    </ImportantInformationScreen.GenericSettingsScreenContainer>
  );
};

export default ImportantInformationScreen;

ImportantInformationScreen.GenericSettingsScreenContainer = styled.div`
  .GenericSettingsScreen .AppListItem .title {
    line-height: inherit;
  }
`;
